import Vue from 'vue';
import {store} from "./store";

if (document.getElementById('nmo-lections')) {
    var lectionFilters = {
        filters: {},
        clearFilters: function () {
            this.filters = {
                'direction_id': null,
                'section_id': null,
                'cycle_id': null,
                'is_nmo': 1,
                'test_not_passed': 0,
                'pagination': null,
                'schedule': 1,
            };
        },
        init: function () {

            var that = this;

            this.clearFilters();

            that.filters.is_nmo = 1;
            $(".nmo").prop('checked', 1);

            $(document).on('getFilters', function (e) {
                that.setFilters(e.detail);
            });

            that.getFilters();

        },
        setFilters: function (filters) {
            var that = this;

            if (!this.filters.section_id) {
                $(".sections-select").find("option[data-insert='true']").remove();
                $.each(filters.sections, function (i, v) {
                    $(".sections-select").append($('<option>', {
                        selected: that.filters.section_id == v.id ? true : false,
                        value: v.id,
                        text: v.name,
                        'data-insert': true
                    }));
                });
            }

            $(".filters-form").removeClass('loading');
        },
        getFilters: function () {
            var that = this;

            lections.fetchLections();
            lections.fetchEvents();

            try {
                $.ajax({
                    url: '/lections/default/get-filters',
                    dataType: "json",
                    data: {
                        params: that.filters
                    },
                    success: function (data) {
                        document.dispatchEvent(new CustomEvent('getFilters', {
                            bubbles: true,
                            detail: data
                        }));
                    },
                    fail: function () {
                        throw new Error('Ошибка получении данных');
                    }
                });

            } catch (e) {
            }
        }
    };
    var month;
    var lections = new Vue({
        el: "#nmo-lections",
        data: {
            lightbox: false,
            hiddenText: false,
            lections: {},
            events: null,
            page: 1,
            pageCount: 0,
            pageEvents: 1,
            pageEventsCount: 0,
            filters: {
                pagination: null
            },
            dayNow: Math.round(new Date().getTime() / 1000),
            delayTime: 14400,
            load: false,
            os: store.state.os,
            get month() {
                return month;
            }

        },
        watch: {},
        filters: {
            plural: function (number, titles) {
                let cases = [2, 0, 1, 1, 1, 2];

                return titles[(number % 100 > 4 && number % 100 < 20) ? 2 : cases[(number % 10 < 5) ? number % 10 : 5]];

            }
        },
        methods: {
            monthTime: function (date) {

                let monthsAll = ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'];
                let monthCurrent = new Date(date ? date * 1000 : new Date()).getMonth();

                if (month !== monthsAll[monthCurrent]) {
                    month = monthsAll[monthCurrent];
                    return month;
                } else {
                    return false;
                }
            },
            classRating: function (rating) {
                return {
                    'best': (rating > 4),
                    'good': (rating > 3 && rating <= 4),
                    'normal': (rating > 2 && rating <= 3),
                    'poorly': (rating > 1 && rating <= 2),
                    'bad': rating <= 1,
                    'none': rating <= 0
                };
            },
            fetchLections: function (append) {
                var self = this;
                this.load = true;
                try {
                    var data = lectionFilters.filters;
                    $.extend(data, {page: this.page});
                    $.ajax({
                        url: '/api/v1/lection/index-nmo',
                        dataType: "json",
                        data: lectionFilters.filters,
                        success: function (data) {
                            if (append === true) {
                                $.each(data.items, function (i, item) {
                                    self.lections.items.push(item);
                                });
                            } else {
                                self.lections = data;
                                self.pageCount = data._meta.pageCount;
                                self.page = 1;
                            }
                            self.load = false;
                        },
                        fail: function () {
                            throw new Error('Ошибка получении данных');
                        }
                    });
                } catch (e) {
                }
            },
            fetchEvents: function (append) {
                var self = this;
                this.load = true;
                $.extend(data, {'is_nmo': 1});
                try {
                    var data = {page: this.pageEvents};
                    $.ajax({
                        url: '/api/v1/event',
                        dataType: "json",
                        data: data,
                        success: function (data) {
                            if (append === true) {
                                $.each(data.items, function (i, item) {
                                    self.events.items.push(item);
                                });
                            } else {
                                self.events = data;
                                self.pageEventsCount = data._meta.pageCount;
                                self.pageEvents = 1;
                            }
                            self.load = false;

                        },
                        fail: function () {
                            throw new Error('Ошибка получении данных');
                        }
                    });

                } catch (e) {

                    console.error(e);

                }
            },
            nextPage: function () {
                this.page = this.page + 1;
                this.fetchLections(true);

            },
            nextPageEvent: function () {
                this.pageEvents = this.pageEvents + 1;
                this.fetchEvents(true);

            },
            setPagination: function (pagination) {

                lections.filters.pagination = pagination;
                lectionFilters.filters.pagination = pagination;

                lectionFilters.getFilters();

                this.fetchLections();
            },
            getLectionMonth: function (date) {
                var month;

                let monthsAll = ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'];
                let monthCurrent = new Date(date ? date * 1000 : new Date()).getMonth();

                if (month !== monthsAll[monthCurrent]) {
                    this.month = monthsAll[monthCurrent];
                    return monthsAll[monthCurrent];
                } else {
                    return false;
                }
            },
            getDelayTime: function (time) {
                let currentDate = Date.now();
                let startDay = new Date(time * 1000 - currentDate);

                var returnStr = '';

                if (startDay.getUTCHours() > 0) {
                    returnStr += startDay.getUTCHours() + ' ч. ';
                }

                if (startDay.getMinutes() > 0) {
                    returnStr += startDay.getMinutes() + ' мин. ';
                }
                return returnStr;
            }
        },
        mounted: function () {
            function func() {
                $('.image-link').magnificPopup({
                    type: 'image',
                    mainClass: 'mfp-with-zoom',
                    closeOnContentClick: true,
                    zoom: {
                        enabled: true,
                        duration: 300,
                        easing: 'ease-in-out',
                        opener: function(openerElement) {
                            return openerElement.is('img') ? openerElement : openerElement.find('img');
                        }
                    }

                });
            }
            setTimeout(func, 2000);

        }
    });
    jQuery(document).ready(function(){
        lectionFilters.init();
    });
}